import axios, {HttpStatusCode} from "axios";

export const createClub = async (clubName) => {
    try {
        const response = await axios.post(
            `${process.env.REACT_APP_BACKEND_URL}/club/create`,
            { clubName: clubName }, // Backend expects { clubName: clubName } based on router
            { withCredentials: true }
        );
        return response.data; 
    } catch (error) {
        if (error.response && error.response.data && error.response.data.message) {
            throw new Error(error.response.data.message); // Propagate backend's error message
        } else if (error.response) {
            // If backend sends an error status but no specific message
            throw new Error(`Club creation failed with status code ${error.response.status}`);
        } else {
            // For network errors or other issues
            throw new Error(error.message || 'Failed to create club due to a network or unexpected error.');
        }
    }
};

export const fetchClubs = async () => {
    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/club/list`, {withCredentials: true})
    if(response.status === HttpStatusCode.Forbidden || response.status === HttpStatusCode.Unauthorized) {
        throw new Error("Cannot list clubs - you are not logged in")
    }

    return response.data
}

export const fetchUsers = async (clubName) => {
    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/club/users?clubName=${clubName}`, {withCredentials: true})
    if(response.status === HttpStatusCode.Forbidden || response.status === HttpStatusCode.Unauthorized) {
        throw new Error("Cannot list clubs - you are not logged in")
    }

    return response.data
}

export const createClubInvite = async (clubId, inviteeUsername) => {
    try {
        const response = await axios.post(
            `${process.env.REACT_APP_BACKEND_URL}/club/invite`,
            { clubId: clubId, inviteeUsername: inviteeUsername },
            { withCredentials: true }
        );
        return response.data; 
    } catch (error) {
        if (error.response && error.response.data && error.response.data.message) {
            throw new Error(error.response.data.message);
        } else if (error.response) {
            // If backend sends an error status but no specific message in error.response.data.message
            throw new Error(`Request failed with status code ${error.response.status}`);
        } else {
            // For network errors or other issues where error.response is not available
            throw new Error(error.message || 'Failed to send invite due to a network or unexpected error.');
        }
    }
};

export const fetchClubInvitations = async () => {
    return (await axios.get(`${process.env.REACT_APP_BACKEND_URL}/club/list-invitations`, {withCredentials: true})).data
}

export const handleClubInvite = async (clubId, accepted) => {
    await axios.post(`${process.env.REACT_APP_BACKEND_URL}/club/handle-invitation`, {clubId: clubId, accepted: accepted}, {withCredentials: true});
}

export const leaveClub = async (clubId) => {
    try {
        const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/club/leave`, { clubId }, { withCredentials: true });
        return response.data; 
    } catch (error) {
        console.error("Error leaving club:", error.response || error.message);
        // Re-throw the error or return a specific error object for the caller to handle
        throw error.response ? new Error(error.response.data.message || `Error ${error.response.status}`) : error;
    }
};